import Datepicker from 'components/ReusableComponents/Datepicker'
import { directfulServiceNames } from 'main/directfulServices'
import moment from 'moment'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectCurrentHotelId } from '../../../accessors'
import { updateService } from '../../../actions/hotelDetails'
import styles from '../AddServiceDialog/AddServiceDialog.module.scss'
import ConfirmationDialog from '../ConfirmationDialog/index'
import TextInput from '../ManageHotel/TextInput/index'

const EditServiceDialog = ({ handleClose, service, billingTaxRate }) => {
  const [planRate, setPlanRate] = useState(service.planRate)
  const [showConfirmation, setShowConfirmation] = useState()
  const dispatch = useDispatch()

  const [effectiveDate, setEffectiveDate] = useState(
    service.isActive
      ? service.startDate
        ? new Date(service.startDate)
        : null
      : new Date()
  )

  const hotelId = useSelector(selectCurrentHotelId)

  function editService() {
    dispatch(
      updateService({
        action: 'Update',
        plan: service.plan,
        planRate,
        isFlatMonthly: service.plan !== 'AutoInvite',
        hotelId,
        effectiveFrom: moment(effectiveDate).format('YYYY-MM-DD')
      })
    )
    handleClose()
  }

  function deleteService() {
    setShowConfirmation(false)
    dispatch(
      updateService({
        action: 'Remove',
        plan: service.plan,
        planRate: service.planRate,
        isFlatMonthly: service.plan !== 'AutoInvite',
        hotelId
      })
    )
    handleClose()
  }

  const isEditDisabled = service.isActive
    ? service.startDate && moment(service.startDate).isBefore(moment())
    : false

  return (
    <ConfirmationDialog
      title={`${directfulServiceNames[service.plan]}`}
      onConfirm={editService}
      onClose={handleClose}
      onReject={() => setShowConfirmation(true)}
      negativeMessage={service.isActive ? 'Terminate service' : null}
      positiveMessage={service.isActive ? 'Update service' : 'Activate service'}
      isButtonDisabled={!(planRate !== '')}
    >
      {showConfirmation && (
        <ConfirmationDialog
          title="Terminate service"
          hasDangerousAction
          onClose={() => setShowConfirmation(false)}
          onConfirm={deleteService}
          negativeMessage="No"
          positiveMessage="Yep!"
        >
          <p>Do you want to terminate {service.plan} service?</p>
        </ConfirmationDialog>
      )}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextInput
          value={planRate}
          type="number"
          onChange={e => setPlanRate(e.target.value)}
          className={service.isFlatMonthly ? styles.dollarInput : styles.percentageInput}
        />
        {service.plan !== 'AutoInvite' && (
          <span className={styles.taxText}>
            With tax <br />
            <strong> ${((billingTaxRate / 100 + 1) * planRate).toFixed(2)}</strong>
          </span>
        )}
      </div>
      <div>
        <div className={styles.label}>Effective from</div>
        <Datepicker
          className={styles.datepicker}
          selected={effectiveDate}
          onChange={setEffectiveDate}
          disabled={isEditDisabled}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default EditServiceDialog
